import { render, staticRenderFns } from "./RootContrattiDaVisionareView.vue?vue&type=template&id=3db81dec&"
import script from "./RootContrattiDaVisionareView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiDaVisionareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports